import { render, staticRenderFns } from "./UserRolesForm.vue?vue&type=template&id=5e962431&"
import script from "./UserRolesForm.vue?vue&type=script&lang=js&"
export * from "./UserRolesForm.vue?vue&type=script&lang=js&"
import style0 from "./UserRolesForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports